module.exports = __webpack_public_path__ + "static/media/perfil.0ce91ce1.jpg";